import { Component, OnInit } from "@angular/core";
import { timer } from "rxjs";
import { UserService } from "../../../../shared";
import { MenuService } from "../../services";

@Component({
	selector: "caass-broadcast-messages",
	templateUrl: "./broadcast-messages.component.html",
	styleUrls: ["./broadcast-messages.component.css"],
})
export class BroadcastMessagesComponent implements OnInit {
	constructor(private userService: UserService, private menuService: MenuService) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		this.loadBroadcastAlerts();
	}

	ngOnDestory() {
		this.subscription.unsubscribe();
	}

	//////////////////////////////
	// Data
	//////////////////////////////
	RefreshMinutes: any = -1;
	user: any;
	lstBroadcastAlerts: any = [];

	refreshing: boolean = false;

	subscription: any;
	//////////////////////////////

	//////////////////////////////
	// Load Data
	//////////////////////////////
	loadBroadcastAlerts() {
		if (this.user == undefined || this.user.userID == undefined || this.user.token == undefined || this.user.token_expiration == undefined) {
			return;
		}

		var expDT = new Date(this.user.token_expiration);
		var nowDT = new Date();

		if (nowDT > expDT) {
			return;
		}

		var result = this.menuService.BroadcastAlertTodaySelectList(this.user.userID);
		result.subscribe(
			(response) => {
				this.lstBroadcastAlerts = response;
				this.loadRefreshMinutes();
			},
			(error) => {}
		);
	}

	loadRefreshMinutes() {
		if (this.user == undefined || this.user.userID == undefined || this.user.token == undefined || this.user.token_expiration == undefined) {
			return;
		}

		var expDT = new Date(this.user.token_expiration);
		var nowDT = new Date();

		if (nowDT > expDT) {
			return;
		}

		var result = this.menuService.GetAlertsRefreshMinutes();
		result.subscribe(
			(response: any) => {
				if (response != undefined && response.length != undefined && response.length > 0) {
					this.RefreshMinutes = response[0];
				} else {
					this.RefreshMinutes = 3;
				}

				this.RefreshData();
			},
			(error) => {
				this.RefreshMinutes = 3;

				this.RefreshData();
			}
		);
	}

	async RefreshData() {
		if (!this.refreshing) {
			this.refreshing = true;
			var ms = this.RefreshMinutes * 1000 * 60;

			try {
				this.subscription.unsubscribe();
			} catch (e) {
				console.log(e);
			}

			this.subscription = timer(ms, ms).subscribe((x) => {
				this.loadBroadcastAlerts();
			});
		}
	}

	//////////////////////////////

	//////////////////////////////
	// Helpers
	//////////////////////////////

	GetClass(val) {
		return "Message" + ((val % 10) + 1);
		// var randomNum = Math.floor(Math.random() * 10);
		// return "Message" + ((randomNum % 10) + 1);
	}

	//////////////////////////////
}
